<template>
  <div
    v-if="!!tender && tender.tenderId"
    style="padding-right: 24px;">
    <v-tabs
      ref="tabs"
      v-model="tab"
      background-color="var(--color-main-green)"
      class="tender-tabs tabs mb-5 "
      color="var(--black-color)"
      show-arrows>
      <v-tab
        v-for="(item, index) in tabs"
        :key="index"
        class="tab h7-text-medium px-3'"
        :data-qa="`tab-${item.value}`">
        <BadgeAI
          v-if="item.value == 'aiRequirements'"
          :offset-x="1"
          :offset-y="6"
          :visible="true">
          {{ item.name }}
        </BadgeAI>
        <template v-else>
          {{ item.name }}
        </template>
        <div
          class="tab__badge h9-text-bold black--text'"
          :data-qa="`tab-${item.value}-badge`">
          <span v-if="item.count"> {{ item.count }} </span>
        </div>
      </v-tab>
      <div class="spacer"/>
    </v-tabs>
    <v-tabs-items
      id="content-container"
      v-model="tab"
      class="main__green">
      <v-tab-item
        data-qa="item-tab-lots">
        <ComparativeTableLotGroups
          v-if="lotGroupsView"
          :bids="bids"
          :can-edit="canEdit"
          :tender="tender"
          @changeWinners="$emit('changeWinners')"/>
        <ComparativeTableDefault
          v-else
          :bids="bids"
          :can-edit="canEdit"
          :tender="tender"/>
      </v-tab-item>
      <v-tab-item
        data-qa="item-tab-aiRequirements">
        <EmptyBlock
          v-if="!bidsAndRequirements || !bidsAndRequirements.length"
          custom-class="mt-0 pa-10"
          data-qa="document-noData"
          :text="$t('Tenders.NoData')"/>
        <CollapseBlock
          v-for="(bidsAndRequirement, index) in bidsAndRequirements"
          :key="index"
          class="bid-requirement"
          transparent
          :value="showStates[index]">
          <div
            slot="title"
            class="bid-requirement_title"
            @click.stop="changeState(index)">
            {{ bidsAndRequirement.requirement }}
            <sIcon
              class="ml-2 my-auto"
              :rotate="showStates[index] ? '-180' : '0'"
              size="10"
              type="arrow"/>
          </div>
          <div
            class="bid-requirement-items">
            <div
              v-for="bidsWithResult in bidsAndRequirement.bidsWithResults"
              :key="bidsWithResult.bidId"
              class="bid-requirement-item">
              <div class="bid-requirement-item_title">
                {{ bidsWithResult.supplierName }}
              </div>
              <div class="bid-requirement-item_content">
                <template v-if="bidsWithResult.assessmentStatus">
                  <div class="bid-requirement-item_content-label">
                    {{ $t('AIRequirements.Rating') }}:
                  </div>
                  <div class="bid-requirement-item_content-value text-uppercase">
                    {{ bidsWithResult.assessmentStatus.label }}
                    <sIcon
                      v-if="bidsWithResult.assessmentStatus.icon"
                      class="bid-requirement-item_content-value-icon"
                      :style="{ backgroundColor: bidsWithResult.assessmentStatus.iconBackgroundColor }"
                      :type="bidsWithResult.assessmentStatus.icon"/>
                  </div>
                </template>

                <template v-if="bidsWithResult.comment">
                  <div class="bid-requirement-item_content-label">
                    {{ $t('AIRequirements.AiComment') }}:
                  </div>
                  <div class="bid-requirement-item_content-value">
                    {{ bidsWithResult.comment || '' }}
                  </div>
                </template>
                <div
                  v-if="bidsWithResult.attachment"
                  class="flex gap-3">
                  <DocumentList
                    :attachments="[bidsWithResult.attachment]"
                    class="commercial-offer-document"
                    small/>
                </div>
                <div
                  v-else-if="bidsWithResult.document"
                  class="flex gap-3">
                  <sIcon
                    class="my-auto"
                    :size="18"
                    type="draft"/>
                  <a
                    class="my-auto"
                    @click.prevent="downloadFile(bidsWithResult.document)">
                    {{ $t('Tenders.Document') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </CollapseBlock>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import BadgeAI from 'components/common/elements/BadgeAI.vue'
import CollapseBlock from 'components/common/CollapseBlock.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import DocumentList from 'components/common/blocks/DocumentList.vue'
import ComparativeTableDefault from 'pages/tender item/ComparativeTableDefault.vue'
import ComparativeTableLotGroups from 'pages/tender item/ComparativeTableLotGroups.vue'

import AiApi from '@/api/aiApi'
const aiApi = new AiApi()

export default {
  name: 'ComparativeTableAI',
  data() {
    return {
      tab: 0,
      tenderRequirements: [],
      bidsAndRequirements: [],
      showStates: [],
      // Кэш информации о файлах
      filesInfo: new Map() // ключ: URL, значение: { name, loading, error }
    }
  },
  methods: {
    changeState(index) {
      this.$set(this.showStates, index, !this.showStates[index])
    },    
    // Скачать файл
    downloadFile(fileUrl) {
      try {
        const link = document.createElement('a')
        link.href = fileUrl
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (error) {
        this.$serror('Ошибка при скачивании файла:', error)
        // Fallback - открыть в новой вкладке
        window.open(fileUrl, '_blank')
      }
    },
    
    getRequirement() {
      return new Promise((resolve) => {
        aiApi.getParticipantAssessments(this.tender?.tenderId)
          .then((result) => {
            result = (result?.suppliers ?? []).filter(i => i.status === 'COMPLETED')
            this.tenderRequirements = result.map((requirementItem) => {
              requirementItem.requirements.map((req) => {
                if (req.document) {
                  req.attachment = this.bids.find(bid => bid.bidderInfo.organizationId === requirementItem.supplierId)?.attachments?.find(att => att.title?.trim()?.toLowerCase() === req.document?.trim()?.toLowerCase()) || null
                }
                return req
              })
              return requirementItem
            })

            this.generateBidsAndRequirements()
            resolve()
          })
      })
    },
    generateBidsAndRequirements() {
      // Получаем все уникальные требования из всех поставщиков
      const allRequirements = new Set()
      this.tenderRequirements.forEach(supplier => {
        supplier.requirements?.forEach(req => {
          allRequirements.add(req.requirement)
        })
      })

      // Формируем структуру: для каждого требования список уникальных поставщиков с результатами
      this.bidsAndRequirements = Array.from(allRequirements).map(title => {       
        // Собираем уникальных поставщиков
        const processedSuppliers = new Set()
        const bidsWithResults = []

        this.bids.forEach(bid => {
          const supplierId = bid.bidderInfo?.organizationId
          
          // Если уже обработали этого поставщика, пропускаем
          if (processedSuppliers.has(supplierId)) {
            return
          }
          
          // Добавляем поставщика в обработанные
          processedSuppliers.add(supplierId)
          
          // Находим требования для этого поставщика
          const supplierRequirements = this.tenderRequirements.find(req => 
            req.supplierId === supplierId
          )
          
          // Находим конкретное требование у этого поставщика
          const requirementResult = supplierRequirements?.requirements?.find(req => 
            req.requirement === title
          )

          const getAssessmentStatus = (status) => {
            let label = ''
            let icon = ''
            let iconBackgroundColor = ''
            switch (status) {
            case 'COMPLIES':
              label = this.$t('AIRequirements.StatusesAssessments.COMPLIES')
              icon = 'accept'
              iconBackgroundColor = 'var(--green_chosen)'
              break
            case 'PARTIAL':
              label = this.$t('AIRequirements.StatusesAssessments.PARTIAL')
              icon = 'reminder'
              iconBackgroundColor = 'var(--color-warning)'
              break
            case 'NOT_DETERMINED':
              label = this.$t('AIRequirements.StatusesAssessments.NOT_DETERMINED')
              icon = 'reminder'
              iconBackgroundColor = 'var(--color-warning)'
              break
            case 'NO':
              label = this.$t('AIRequirements.StatusesAssessments.NO')
              icon = 'cancel'
              iconBackgroundColor = 'var(--color-error)'
              break
            case 'CRITICAL_NO':
              label = this.$t('AIRequirements.StatusesAssessments.CRITICAL_NO')
              icon = 'cancel'
              iconBackgroundColor = 'var(--color-error)'
              break
            default:
              label = this.$t('AIRequirements.Statuses.UNDEFINED')
              icon = ''
              iconBackgroundColor = ''
            }
            return { status, label, icon, iconBackgroundColor }
          }

          bidsWithResults.push({
            bid: bid,
            requirementResult: requirementResult || null,
            hasResult: !!requirementResult,
            assessmentStatus: getAssessmentStatus(requirementResult?.assessment || ''),
            comment: requirementResult?.comment || null,
            document: requirementResult?.document || null,
            attachment: requirementResult?.attachment || null,

            supplierName: bid.bidderInfo?.organizationName || '-',
            supplierId: supplierId,
            bidId: bid.id
          })
        })

        return {
          requirement: title,
          bidsWithResults: bidsWithResults
        }
      })
    },
  },
  computed: {
    tabs() {
      let tabs = [
        {
          name: this.$t('Tenders.Lots'),
          value: 'lots',
          count: this.lotGroupsView ? this.tender?.lotGroups?.length : this.tender?.lots?.length
        },
        {
          name: this.$t('Tenders.Requirements'),
          value: 'aiRequirements',
        },
      ]
      return tabs
    }
  },
  components: {
    BadgeAI,
    EmptyBlock,
    DocumentList,
    CollapseBlock,
    ComparativeTableDefault,
    ComparativeTableLotGroups
  },
  async created() {
    this.getRequirement()
  },
  props: {
    tender: {
      type: Object,
      required: true
    },
    bids: {
      type: Array,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    /** режим лот-позицій — таблиця по лотах (групах позицій) */
    lotGroupsView: {
      type: Boolean,
      default: false
    },
  },
}
</script>
<style lang="scss" scoped>
$border-radius: 10px;

$block-item: '.bid-requirement-item';

.bid-requirement {
  background: #EBF6F5;
  margin-bottom: 24px;
  &_title {
    display: flex;
    align-items: center;
    gap: 24px;
    align-self: stretch;
    font-weight: 600;
    padding-bottom: 24px;
    justify-content: space-between;
    border-bottom: 1px solid var(--white-color);
  }
}
.bid-requirement-items {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(352px, 1fr));
  width: 100%;
  padding: 26px 0 26px;
  border-radius: $border-radius;
  &>:first-child {
    border-top-left-radius: $border-radius;
    border-bottom-left-radius: $border-radius;
    #{$block-item}_title {
      border-top-left-radius: $border-radius;
    }
  }
  &>:last-child {
    border-top-right-radius: $border-radius;
    border-bottom-right-radius: $border-radius;
    #{$block-item}_title {
      border-top-right-radius: $border-radius;
    }
  }
}
#{$block-item} {
  text-align: left;
  background: #EBF6F5;
  &_title {
    padding: 13px 12px;
    background-color: #D8F1F0;
    font-size: 13px;
    font-weight: 600;
    line-height: 14px;
    text-transform: uppercase;
  }
  &_content {
    padding: 26px 12px;
    &-label {
      opacity: 0.8;
      font-size: 11px;
      line-height: 14px;
      margin-bottom: 4px;
      text-transform: uppercase;
    }
    &-value {
      margin-bottom: 12px;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      gap: 5px;
      &-icon {
        opacity: 0.8;
        border-radius: 50%;
      }
    }
  }
}
</style>